@if (isAuthoring || showContent) {
  <div class='plan-change-content'>
    <slot name="plan_change_content"></slot>
  </div>
}